// extracted by mini-css-extract-plugin
module.exports = {"offlineBanner":"OfflineBanner_offlineBanner__18UWX","offlineButton":"OfflineBanner_offlineButton__1X7Ba"};